import dayjs from "dayjs";
import { toast } from "sonner";

export const EMAIL_LABEL = { sent: "email sent", no_email: "no email on file", failed: "email failed" };
export const lastReminder = (x) => (x.reminders || [])[(x.reminders || []).length - 1];
export const remindedRecently = (x) => !!x.last_reminder_at && dayjs().diff(dayjs(x.last_reminder_at), "hour") < 24;
export const canRetryEmail = (x) => remindedRecently(x) && lastReminder(x)?.email === "failed" && (lastReminder(x).email_retries || []).length < 3;

/** One toast that says exactly what reached the client. */
export function reminderToast(entry, retry) {
  if (entry.email === "failed") return toast.warning(retry ? "The email still did not go through. Try again in a few minutes." : "Portal notice sent, but the email did not go through. Use Retry email.");
  if (entry.email === "no_email") return toast.success("Portal notice sent. This client has no email on file.");
  return toast.success(retry ? `Reminder email sent to ${entry.to}` : `Portal notice sent and emailed to ${entry.to}`);
}
